<template>
  <div class="meetingOrder">
    <div class="title">设置会议提报单信息</div>
    <el-form
      ref="ruleForm"
      :model="formData"
      label-width="130px"
      :inline="true"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="提报部门" prop="signTableName">
            <el-input
              v-model="formData.operatorDeptName"
              readonly=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会议时间">
            <el-date-picker
              v-model="formData.conferenceTime"
              type="datetime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会议议题" prop="contractName">
            <el-input v-model="formData.title" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会议类别" prop="signTableName">
            <el-radio-group
              v-model="formData.conferenceType"
              style="margin-top: 12px; margin-left: 4px"
            >
              <el-radio label="党委会"></el-radio>
              <el-radio label="董事会"></el-radio>
              <el-radio label="总经理办公室"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-bottom:20px">
        <el-col :span="24">
          <el-form-item label="主要内容" prop="agreeOn">
            <el-input
              type="textarea"
              v-model="formData.content"
              :rows="6"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="参会部门及其负责人">
            <!-- <el-input
              type="textarea"
              v-model="formData.checkWorkList"
              readonly
            ></el-input> -->
          </el-form-item>
        </el-col>
      </el-row>

      <template v-for="(item, index) in formData.approveInfoList">
        <el-row :key="item.id">
          <el-col :span="7">
            <el-form-item
              :label="`审批人${index + 1}`"
              label-width="130px"
              prop="serialNumber"
            >
              <el-input v-model="item.approveUserName" readonly=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="margin-left: 30px">
            <el-form-item label="" label-width="10px">
              <el-input v-model="item.deptKeyName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="margin-top: 24px">
            <div class="checkboxWrap">
              <el-checkbox v-model="item.isPrint" style="width: 40px" label="1"
                >打印
              </el-checkbox>
            </div>
            <!-- <el-form-item label="打印显示部门">
              <PrintDeptSelectComponent
                :value="item.deptKey"
                :placeholder-name="item.deptKeyName"
                @handleSave="
                  (e) => {
                    handleChangeDeptCom(e, index);
                  }
                "
              ></PrintDeptSelectComponent>
            </el-form-item> -->
          </el-col>
          <el-col :span="4" style="margin-top: 24px">
            <div class="checkboxWrap">
              <el-checkbox
                v-model="item.isLeaderOpinion"
                style="width: 40px"
                label="1"
                >集团分管领导意见
              </el-checkbox>
            </div>
          </el-col>
        </el-row>
      </template>
      <el-row>
        <el-col :span="10">
          <el-form-item label="联系人" prop="contactUserName">
            <el-input v-model="formData.contactUserName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            class="marginLeft8"
            @click="showApplyUserDia('contactUserName')"
            >选择</el-button
          >
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话">
            <el-input
              v-model="formData.contactUserPhone"
              @input="updateValue"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="bottomBtn">
      <el-button type="primary" @click="print">打印预览</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
    <ApplyUserDialog
      @dialogClose="applyUserDiaVisible = false"
      @SaveApplyUser="saveApplyUser"
      @close="closeDialog"
      :applyUserName="applyUserName"
      :applyUserDiaVisible="applyUserDiaVisible"
    ></ApplyUserDialog>
    <MeetingOrderPrint
      :visible.sync="printVisible"
      :printData="formData"
      v-if="printVisible"
    >
    </MeetingOrderPrint>
  </div>
</template>

<script>
import {
  getDeclarationDetail,
  createOrUpdateDeclarationPrint,
  queryApproveInfoOfDeclaration,
} from "@/services/declarationServices";
import {
  getDeptListService, //根据组织获取项目部一级数据下拉列表
} from "@/services/sysSettingService";
import ApplyUserDialog from "@/page/contract/commonCell/ApplyUserDialog";
import MeetingOrderPrint from "./MeetingOrderPrint";
// import DeptSelectComponent from "./DeptSelectComponent";
// import PrintDeptSelectComponent from "./PrintDeptSelectComponent";

export default {
  name: "approveAndSign",
  props: {
    itemId: {
      type: String,
    },
    approveType: {
      type: String,
    },
  },
  components: {
    ApplyUserDialog,
    MeetingOrderPrint,
    // DeptSelectComponent,
    // PrintDeptSelectComponent,
  },
  data() {
    return {
      formData: {},
      applyUserDiaVisible: false, //选择申请人弹窗
      applyUserDiaType: "", //申请人
      applyUserName: "",
      subDeptList: [], //部门列表
      printVisible: false,
    };
  },
  watch: {
    itemId: {
      handler: function (newVal) {
        if (newVal) {
          this.getDeclarationDetail(this.itemId);
        }
      },
      immediate: true,
    },
  },
  // created() {
  //   this.getProjectClubList(0); //获取部门一级下拉列表
  // },
  methods: {
    //获取一条会议提报单信息
    getDeclarationDetail(id) {
      getDeclarationDetail({ id: id })
        .then((res) => {
          if (res.code == 10000000) {
            let formData = res.data;
            const data = formData.declarationPrintVO || {};
            if (!res.data.declarationPrintVO) {
              queryApproveInfoOfDeclaration({ id: id }).then((res1) => {
                if (res1.code == 10000000) {
                  const approveInfoList = res1.data || [];
                  if (approveInfoList.length > 0)
                    approveInfoList[
                      approveInfoList.length - 1
                    ].isLeaderOpinion = true;
                    approveInfoList.forEach(item => {
                      if(!item.isLeaderOpinion)
                      {
                        item.isLeaderOpinion=false
                      }
                      return item
                      
                    });
                  this.formData = {
                    ...data,
                    approveInfoList,
                    operatorDeptName: formData.operatorDeptName,
                    title: formData.title,
                    content: formData.content,
                  };
                  if (formData.checkWorkJson) {
                    console.log(JSON.parse(formData.checkWorkJson));
                    this.formData.checkWorkList = JSON.parse(
                      formData.checkWorkJson
                    )
                      .map((e) => e.name)
                      .join("、");
                  }
                }
              });
            } else {
              const approveInfoList = data?.approveInfoList || [];
              this.formData = {
                ...data,
                approveInfoList,
                operatorDeptName: formData.operatorDeptName,
                title: formData.title,
                content: formData.content,
              };
              if (res.data.checkWorkJson) {
                console.log(JSON.parse(res.data.checkWorkJson));
                this.formData.checkWorkList = JSON.parse(res.data.checkWorkJson)
                  .map((e) => e.name)
                  .join("、");
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    //获取项目部下拉列表数据
    getProjectClubList(deptId) {
      let reqParam = {
        pid: deptId,
        orgId: sessionStorage.getItem("orgId"),
      };
      getDeptListService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            console.log("--- subDeptList", res.data);
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    submit() {
      // const isFull = approveInfoList.every((i) => i.deptKey);
      // if (!isFull) {
      //   this.$message.error("请选择打印部门");
      //   return;
      // }
      let newOj = { ...this.formData };
      newOj.approveInfoList = this.formData.approveInfoList;
      createOrUpdateDeclarationPrint({
        ...newOj,
        declarationId: this.itemId,
      })
        .then((res) => {
          if (res.code == 10000000) {
            this.$alert("保存成功", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert(res.msg, "确定");
          }
        })
        .catch((err) => {
          this.$message.error("网络请求失败");
        });
    },
    print() {
      this.printVisible = true;
      this.$emit("handlePrint", {
        formData: this.formData,
        approveList: this.approveList,
      });
    },
    showApplyUserDia(type) {
      this.applyUserDiaType = type;
      this.applyUserDiaVisible = true;
    },
    closeDialog() {
      this.applyUserDiaVisible = false;
    },
    //部门数据改变时更新数据
    handleChangeDept(value) {
      this.formData.handleDeptId = value[value.length - 1];
      let labels = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels;
      this.formData.handleDeptName = labels[labels.length - 1];
    },
    handleChangeDeptCom(e, index) {
      this.$set(this.formData.approveInfoList[index], "deptKey", e.value);
      this.$set(this.formData.approveInfoList[index], "deptKeyName", e.label);
    },
    //存储申请人
    saveApplyUser(selectItems) {
      this.formData.contactUserName = selectItems.applyUserName;
      this.formData.contactUserId = selectItems.applyUserId;
      this.formData.contactUserPhone = selectItems.phone;

      this.applyUserDiaType = "";
      this.applyUserDiaVisible = false;
    },
    updateValue(val) {
      this.formData.contactUserPhone = val;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.meetingOrder {
  margin-bottom: 30px;
  .title {
    margin: 10px 0;
  }

  .marginLeft8 {
    margin-top: 18px;
    margin-left: 4px;
  }

  .approverWrap {
    border: 1px solid #dcdfe6;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;

    .approverSingleWrap {
      position: relative;
      flex: 1;

      .comments {
        height: 22px;
        text-align: center;
        line-height: 22px;
      }

      .user {
        text-align: right;
        position: absolute;
        line-height: 14px;
        right: 18px;
        bottom: 5px;
      }
    }
  }

  .checkboxWrap {
    width: 110px - 12px;
    text-align: left;
    margin-left: 10px;
  }

  .bottomBtn {
    bottom: 21px;
  z-index: 100;
  left: 676px;
    // z-index: 100;
    // left: 120px;
    position: fixed;
    // bottom: 20px;
    // height: 40px;
    // line-height: 40px;
    background: #fff;
    // width: 250px;
  }
}
</style>
